import useRedirectHome from 'hooks/useRedirectHome';

const HomePage = () => {
  useRedirectHome();
  return null;
};

export default HomePage;
